import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { heureka } from "@otto-ec/heureka";
import type { Appendable } from "../util/Appendable";

const CLASS_NEXT_BEST_ACTION_WRAPPER = "hc_nextBestAction";

export class NextBestActionComponent implements Appendable {
  static readonly factory = HeurekaElementFactory.byClass(CLASS_NEXT_BEST_ACTION_WRAPPER, NextBestActionComponent);

  /*               */

  constructor(readonly nextBestAction: HTMLElement) {}

  /*               */

  init() {
    this.registerListener();
    return this;
  }

  private onchange(event: Event) {
    heureka.filterSection_change.emit({ target: event.target });
  }

  registerListener() {
    this.nextBestAction.addEventListener("change", this.onchange);
  }

  appendTo(elem: HTMLElement): void {
    elem.appendChild(this.nextBestAction);
  }
}
